import { useEffect, useState } from 'react';

/**
 * Column counts of `.ij-product-grid--featured` — these MUST stay in step
 * with the breakpoints in `styles/_components.scss`, because the featured
 * grids trim their last ragged row using this number.
 *
 * Ordered widest-first: the first matching query wins.
 */
const BREAKPOINTS = [
  { query: '(min-width: 1200px)', columns: 5 },
  { query: '(min-width: 900px)', columns: 4 },
  { query: '(min-width: 640px)', columns: 3 },
];

const NARROW_COLUMNS = 2;
const WIDEST_COLUMNS = BREAKPOINTS[0].columns;

const readColumns = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return WIDEST_COLUMNS;
  const match = BREAKPOINTS.find(({ query }) => window.matchMedia(query).matches);
  return match ? match.columns : NARROW_COLUMNS;
};

/** How many cards the featured grid fits per row at the current width. */
const useGridColumns = () => {
  const [columns, setColumns] = useState(readColumns);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const lists = BREAKPOINTS.map(({ query }) => window.matchMedia(query));
    const update = () => setColumns(readColumns());

    // Safari < 14 only has the deprecated addListener/removeListener pair.
    lists.forEach((list) =>
      list.addEventListener
        ? list.addEventListener('change', update)
        : list.addListener(update)
    );
    update();

    return () =>
      lists.forEach((list) =>
        list.removeEventListener
          ? list.removeEventListener('change', update)
          : list.removeListener(update)
      );
  }, []);

  return columns;
};

/** Largest multiple of `columns` that fits in `count`, never returning 0. */
export const wholeRows = (count, columns) => {
  if (!columns || count < columns) return count;
  return count - (count % columns);
};

export default useGridColumns;
